import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo, useEffect } from "react";
export const FlowContext = createContext({
    flowState: [],
    setFlowState: () => { },
    selectedEntitiesSet: new Set(),
    setSelectedEntitiesSet: () => { },
});
export const FlowProvider = ({ initialState = [], children, }) => {
    const [flowState, setFlowState] = useState(initialState);
    const [selectedEntitiesSet, setSelectedEntitiesSet] = useState(new Set([]));
    useEffect(() => {
        if (flowState.length === 0) {
            setFlowState(initialState);
        }
    }, [flowState, initialState]);
    const contextValue = useMemo(() => ({
        flowState: flowState || [],
        setFlowState,
        selectedEntitiesSet,
        setSelectedEntitiesSet,
    }), [flowState, setFlowState, selectedEntitiesSet, setSelectedEntitiesSet]);
    return (_jsx(FlowContext.Provider, { value: contextValue, children: children }));
};
